import stile from './stile.module.css';

function ToastSuccesso(props) {
  if (!props.visibile) return null;

  var classeToast = stile.toastVerde;

  if (props.tipo === "rosso") {
    classeToast = stile.toastRosso;
  }

  return (
    <div className={[stile.toast, classeToast].join(" ")}>
      {props.testo}
    </div>
  );
}

export default ToastSuccesso;